import React, { useContext, useEffect, useState } from 'react'
import { ContextGloball } from '../Context/ContextGlobal';
import MsgUtils from '../Tools/MsgUtils';
import ItemSucursalCajaCierre from './ItemSucursalCajaCierre';
const server = process.env.REACT_APP_SERVER;
function CierreCaja() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [idEmpleado, setIdEmpleado] = useState(JSON.parse(localStorage.getItem('info')).ID_EMPLEADO);
    const [fecha, setFecha] = useState('');
    const [sucursales, setSucursales] = useState([]);
    const [actualizar,setActualizar] = useState(false);
    function obtenerSucursales() {
        if (sucursales.length == 0) {
            setLoading(true);
            fetch(`${server}/sqlComun/getSucursales`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': JSON.parse(localStorage.getItem('__react_session__')).regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false);
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        setSucursales(data.ok)
                    }
                })
                .catch(error => MsgUtils.msgError(error));
        }
    }
    useEffect(() => {
        obtenerSucursales();
    }, [])
    return (
        <>
            <div className='bg-dark bg-gradient container-fluid py-1'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ maxWidth: '175px' }}>
                        <div className="input-group input-group-sm" >
                            <span className="text-light mx-1 my-auto" >Fecha</span>
                            <input type="date" className="form-control"
                                title='Elija una fecha'
                                value={fecha} onChange={(e) => setFecha(e.target.value)} />
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '100px' }}
                        onClick={()=>{
                            if(fecha!=''){
                                setActualizar(!actualizar)
                            }else{
                                MsgUtils.msgError('Seleccione la fecha, Por favor ...')
                            }
                        }}>
                        <button className='btn btn-sm btnNaranja w-100'><i className="fa-solid fa-magnifying-glass"></i> Buscar</button>
                    </div>
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-dark table-sm table-bordered border-secondary">
                    <thead className='text-center'>
                        <tr>
                            <th scope="col"></th>
                            <th colspan="2">Pollo</th>
                            <th colspan="2">Pipoca</th>
                            <th colspan="2">Arroz</th>
                            <th colspan="2">Frijol</th>
                            <th colspan="2">Helado</th>
                            <th colspan="2">Jugos</th>
                        </tr>
                        <tr>
                            <th scope="col">sucursal</th>
                            <th scope="col">Mañana</th>
                            <th scope="col">Noche</th>
                            <th scope="col">Mañana</th>
                            <th scope="col">Noche</th>
                            <th scope="col">Mañana</th>
                            <th scope="col">Noche</th>
                            <th scope="col">Mañana</th>
                            <th scope="col">Noche</th>
                            <th scope="col">Mañana</th>
                            <th scope="col">Noche</th>
                            <th scope="col">Mañana</th>
                            <th scope="col">Noche</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sucursales.map((item,index)=>{
                            return(<ItemSucursalCajaCierre sucursal={item} fecha={fecha}
                                actualizar={actualizar} idEmpleado={idEmpleado}
                                key={index}/>)
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default CierreCaja